import api from './client'

export const getMe = () => api.get('/auth/me')

// Invoices
export const getInvoices = (params) => api.get('/invoices/', { params })
export const getInvoice = (id) => api.get(`/invoices/${id}`)
export const createInvoice = (data) => api.post('/invoices/', data)
export const updateInvoice = (id, data) => api.put(`/invoices/${id}`, data)
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`)
export const updateInvoiceStatus = (id, status) => api.patch(`/invoices/${id}/status`, null, { params: { status } })
export const canEditInvoice = (id) => api.get(`/invoices/${id}/can-edit`)

// Customers
export const getCustomers = (search = '') => api.get('/customers/', { params: { search } })
export const getAllCustomers = () => api.get('/customers/', { params: { search: '' } })
export const createCustomer = (data) => api.post('/customers/', data)
export const updateCustomer = (id, data) => api.put(`/customers/${id}`, data)
export const deleteCustomer = (id) => api.delete(`/customers/${id}`)

// Products
export const getProducts = (search = '') => api.get('/products/', { params: { search } })
export const getAllProducts = () => api.get('/products/', { params: { search: '' } })
export const createProduct = (data) => api.post('/products/', data)
export const updateProduct = (id, data) => api.put(`/products/${id}`, data)
export const deleteProduct = (id) => api.delete(`/products/${id}`)

// Users
export const getUsers = () => api.get('/users/')
export const createUser = (data) => api.post('/users/', data)
export const updateUser = (id, data) => api.patch(`/users/${id}`, data)
export const deleteUser = (id) => api.delete(`/users/${id}`)

// Edit Requests
export const getEditRequests = (status = '') => api.get('/edit-requests/', { params: { status } })
export const getPendingCount = () => api.get('/edit-requests/pending-count')
export const createEditRequest = (data) => api.post('/edit-requests/', data)
export const approveEditRequest = (id) => api.patch(`/edit-requests/${id}/approve`)
export const rejectEditRequest = (id) => api.patch(`/edit-requests/${id}/reject`)

// Dashboard
export const getDashboardStats = (date_from, date_to) => api.get('/dashboard/stats', { params: { date_from, date_to } })
export const getReports = (params) => api.get('/dashboard/reports', { params })
export const exportReportsCSV = (params) => api.get('/dashboard/reports/csv', { params, responseType: 'blob' })
